import { message as antdMessage, Space, Spin } from "antd"
import {
    useContext,
    useRef,
    useState
} from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { login } from "../../endpoints"
// import CryptoJS from "crypto-js"

import { useTheme } from "styled-components"
import {
    Container,
    FullRow,
    PrimaryRowButton,
    RowInput,
    Title
} from "../../components"
import { sha256 } from "../../config"
import { UserDispatchContext } from "../../context"
import { Row, Col } from "antd";
import plasmidOverlay from "../../images/plasmidOverlay.png";


export function Login({
  redirect_link,
}: {
  redirect_link?: string
}): JSX.Element {
  const [messageApi, contextHolder] = antdMessage.useMessage()
  const location = useLocation()
  // const queryClient = useQueryClient()
  const theme = useTheme()
  const redirectTo = redirect_link
    ? redirect_link
    : location.state?.redirect_link
    ? location.state.redirect_link
    : "/myspace"
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const navigate = useNavigate()
  const dispatch = useContext(UserDispatchContext)


  const [error, setError] = useState<string | null>(null)
  const emailInputRef = useRef<HTMLInputElement>(null)

  // Email validation helper
  function isValidEmail(email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    setError(null) // Reset error state
      if (!email) {
      setError("Please enter your email address.")
      emailInputRef.current?.focus()
      return
    }
    if (!isValidEmail(email)) {
      setError("Please enter a valid email address.")
      emailInputRef.current?.focus()
      return
    }
    if (!password) {
      setError("Please enter a password.")
      return
    }
    if (email.length > 0 && password.length > 0) {
      setLoading(true)
      // const hash=await hashPassword(password+'plab')
      // consolelog('hash',hash)
      try {
        const hash = await sha256(password + "plab")
        const res = await login({ email, password: hash })
        if (res.code === 1000) {
          dispatch?.({
            type: "LOGIN",
            payload: res.user ?? { user: null, supervisor: null },
          })
          messageApi.success({ content: "You have successfully logged in." })
          // queryClient.invalidateQueries({ queryKey: ["getuserinsession"] })
          navigate(redirectTo ?? "/")
        } else {
          setError("Incorrect email or password.")
          // messageApi.warning({ content: "Incorrect user name or password!" })
        }
      } catch (e) {
        setError("Server error, please try again later.")
        // messageApi.error({ content: "Server error, please try again later" })
      } finally {
        setLoading(false)
      }
    }
  }

  return (
      <Row style={{ minHeight: "80vh" }}>
    <Col xs={24} md={12} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Container style={{ marginTop: "3.5em", minWidth: 320, maxWidth: 420, width: "100%" }}>

    <Container style={{ marginTop: "3.5em" }}>
      {contextHolder}
      <FullRow>
        <Title>Welcome Back!</Title>
      </FullRow>
      <FullRow>
        <RowInput
          placeholder="Email Address"
          type="email"
          id="login"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          name="email"
          maxLength={60}
        />
      </FullRow>
      <FullRow>
        <RowInput
          placeholder="Password"
          type="password"
          id="password"
          value={password}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSubmit()
          }}
          onChange={(e) => setPassword(e.target.value)}
          name="password"
          maxLength={40}
        />
      </FullRow>
      {error && (
        <FullRow>
          <span style={{ color: "red", fontSize: "1em" }}>{error}</span>
        </FullRow>
      )}
      <FullRow>
        <PrimaryRowButton type="primary" onClick={handleSubmit} id="submit" disabled={loading}>
          {loading ? <Spin size="small" /> : "Login"}
        </PrimaryRowButton>
      </FullRow>
      <FullRow style={{ marginBottom: "30px" }}>
        <Space>
          <Link to="/register" style={{ color: theme.primary }}>
            Register
          </Link>
          |
          <Link to="/forgotpassword" style={{ color: theme.primary }}>
            Forgot Password?
          </Link>
        </Space>
      </FullRow>
     
    </Container>
 </Container>
       </Col>
      <Col xs={0} md={12} 
        style={{
      position: "relative",
      overflow: "hidden",
      minHeight: "80vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
          borderLeft: "1px solid #D3D3D3", // Add black border on the right side column
      }}>
      <img
        src={plasmidOverlay}
        alt="Plasmid"
        style={{
          position: "absolute",
          left: "-50%",
          top: 0,
          height: "100%",
          width: "auto",
          opacity: 0.3,
          objectFit: "cover",
          zIndex: 1,
          maxWidth: "none",
        }}
        draggable={false}
      />
      <div
        style={{
          zIndex: 3,
          color: "#fff",
          textAlign: "center",
          fontWeight: 700,
          fontSize: "2.5rem",
          textShadow: "0 2px 16px rgba(0,0,0,0.35)",
          pointerEvents: "none",
          padding: "0 2rem",
        }}
      >
        Start Sequencing Today
      </div>
    </Col>
  </Row>
  )
}
